import { DialogUI } from '../Interface';
import { useEffect } from 'react';
import DocumentPage from './DocumentPage';
import { useDoc } from '../../hooks/useDoc';

const DocDialog = ({ open, handleClose, data, docTypeId }) => {
  const docState = useDoc({ docTypeId });

  useEffect(() => {
    if (data) {
      docState.setSelectedValues(data);
    }
  }, [data, docState]);

  return (
    <DialogUI
      open={open}
      onClose={handleClose}
      headerContent={data?.docName ?? 'Bizonylat'}
      sx={{
        '& .MuiDialog-container': {
          '& .MuiPaper-root': {
            width: '100%',
            maxWidth: '1400px',
          },
        },
      }}
    >
      <div className="mt-5">
        <DocumentPage
          dialog={{
            handleClose: handleClose,
          }}
          docState={docState}
        />
      </div>
    </DialogUI>
  );
};

export default DocDialog;
